/**
 * Old Info links (/info/v2/..., /info/v3/...). next.config redirects them on a full page load, but a client-side
 * navigation (a <Link> inside the app) skips those redirects and lands on /info/[dex] with dex = "v3", which the
 * guard showed as "Unknown DEX" (2026-10-06: the home "Info" card linked /info/v3). Same mapping as next.config.
 *
 * 2026-10-06 (Bez): the PancakeSwap tab is gone; "Smart Swap" replaces it. Its overview and its pools / tokens lists land on the
 * Smart Swap tab. A PancakeSwap pool or token page (/info/pancakeswap/pools/0x…, /tokens/0x…) stays: the token and competition
 * pages link there (the PancakeSwap pools of CADINU and CBON).
 */
const LEGACY = /^\/info\/(v2|v3)(?:\/(pairs|pools|tokens)(?:\/(0x[0-9a-fA-F]{40}))?)?\/?$/
const PANCAKE_TAB = /^\/info\/pancakeswap(?:\/(?:pools|tokens))?\/?$/
export const SMART_SWAP_PATH = '/info/smart-swap'

export function legacyInfoTarget(asPath: string): string | null {
  const [path] = asPath.split(/[?#]/)
  if (PANCAKE_TAB.test(path)) return SMART_SWAP_PATH
  const m = LEGACY.exec(path)
  if (!m) return null
  const [, version, section, address] = m
  const sec = section === 'pairs' ? 'pools' : section
  return `/info/cadinu${sec ? `/${sec}` : ''}${address ? `/${address}` : ''}?v=${version}`
}
